$(document).ready(function () {
    allCatData = $('#fasAllCatData').data('value');
    var currentSessionZipCode = $('#currentSessionZipCode').attr('data-value');
    if (!isNullUndefined(currentSessionZipCode) && validateFindStoreZipCode(currentSessionZipCode)) {
    	$('.fas-page-store-msg').text($('#fasPageFetchingStoresMsg').attr('data-value'));
    	$('.sd-page-store-msg').text($('#fasPageFetchingStoresMsg').attr('data-value'));
        $('.fas-zc-set').removeClass("d-none");
        $('.fas-zc-set-p').removeClass("d-none");
 
    } else {
        $('.fas-not-zc-set').removeClass("d-none");
        $('.fas-not-zc-set-p').removeClass("d-none");
    }
    
  

    //on page load set address in inut
    let setInputAddress = $('#currentAddress').data('address');
    if(!isNullUndefined(setInputAddress)) {
        $('#stateZipInput').val(setInputAddress);
    }

    //How lease works
    $('.toggle-btn, .close-lease, .close-cross-img').on('click', function() {
        $('.lease-content').toggleClass('d-none');
        $('.faq-plus-sign').toggleClass('d-none');
        $('.faq-minus-sign').toggleClass('d-none');
		if($(this).attr('data-attr') == "true"){
			window.dataLayer.push({
	      		'event': 'findStoreHowLTOWorksModal'
	   		});
		}
    })

    //mobile category dropdown
    mobileCatDropdown();
    //BacktoTop button
    backTotop();
    $(`.particular-category[data-categorytitle="${allCatData}"]`).addClass('category-active');
    
    $('#stateZipInput').on('input', function(event) {
        setTimeout(() => {
            if(!isNullUndefined(event.target.value)) {
                updateAutocomplete(event.target.value)
            }
            else {
                $('#autocompleteOptions').addClass('d-none');
            }
        }, 300);
    })

    //code to fetch stores when autosuggetion address hits
    $('#autocompleteOptions').on('click', 'li', function() {
        currentAddress = $(this).text().trim();
        let selectedRegionAddress = $(this).text().trim();
        $('#stateZipInput').val(selectedRegionAddress);
        $('#autocompleteOptions').empty().addClass('d-none');
        $('.stores-list-wrapper').empty()
        //Call to get the formated Address and the zipcode.
        $('.mobile-empty-store-error').addClass('d-none');
        $('.fetch-stores-loader').removeClass('d-none');
        $('.store-input').addClass('input-disabled');
        $('#stateZipInput').blur();
        appendDataByAddress(selectedRegionAddress);
    });

    //code to fetch stores when user allows location
    $('.findstore-use-location').on('click', function() {
        $('.stores-list-wrapper').empty()
        $('#storeNotFoundError').addClass('d-none');
        $('.store-input').removeClass('error-border');
        //Call to get the formated Address and the zipcode.
        $('.mobile-empty-store-error').addClass('d-none');
        $('.fetch-stores-loader').removeClass('d-none');
        $('.store-input').addClass('input-disabled');
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                function (successCallback) {
                    appendDataByUserLocation(successCallback);
				},
				function (errorCallback) {
					console.log(errorCallback)
				},
            )
        }
    })

    //code to findstore when zipcode enter on modal popup
    $('#zip').on('keypress', function(event) {
        if (event.which === 13) {
            event.preventDefault();
            $('#storeModalPopup').submit();
        }
    });
	$('#storeModalPopup').on('submit', function(event) {
		event.preventDefault();
		let zipCode = $('#zip').val();
        if(validateFindStoreZipCode(zipCode)) {
            appendDataByZipcode(zipCode);
        }
        else {
            $('#lessCharError').removeClass('d-none');
            $('.zip-input').addClass('error-border');
            controlZipCodeError();
        }
	})

    //user hits submit button
    $('#storeSearchForm').on('submit', function(event) {
        event.preventDefault();
        let selectedRegionAddress = $('#stateZipInput').val();
        $('.store-input').addClass('input-disabled');
        $('#stateZipInput').blur();
        appendDataByAddress(selectedRegionAddress);
        $('#autocompleteOptions').empty().addClass('d-none');
    });

    //OnClick of searchThisAreaButton
    $(document).on('click', '#search-this-area', function() {
        searchThisArea();
    })

	$(document).on('click', '.findStoreApplyNow', function() {
	   var locationGuid = $(this).attr('data-locationGuid');
	   if (!isNullUndefined(locationGuid) && locationGuid.includes('location_guid=')) {
	      locationGuid = locationGuid.split("location_guid=").pop();
	   }
	   var storeName = $(this).attr('data-storeName');
	   var categories = $(this).attr('data-categories');
	   if (!isNullUndefined(categories)) {
	      categories = categories.slice(1, -1);
	   }
	   window.dataLayer.push({
	      'event': 'applyNow',
	      'location_guid': locationGuid,
	      'storeName': storeName,
	      'storeCategory': [{
	         'label': categories
	      }],
	      'resultNumber': 1
	   });
	})
	
	$(document).on('click', '.store-finder-phone', function() {
	   var locationGuid = $(this).attr('data-locationGuid');
	   if (!isNullUndefined(locationGuid) && locationGuid.includes('location_guid=')) {
	      locationGuid = locationGuid.split("location_guid=").pop();
	   }
	   window.dataLayer.push({
	      'event': 'storePhoneClick',
	      'location_guid': locationGuid
	   });
	});

    updateAddCookieParams(['.apply-now-button .acima-button-primary','.apply-for-both-btn .acima-button-primary','.est-leasing-cost']);
    autoCompleteKeyNavigation();

});
let allCatData;
let currentAddress;

function filterCategoriesIfExist() {
    let onLoadCategory = $('#selectedCategoryName').data('category');
    let categoryExists = false;
    // Iterate through each div with class 'particular-category'
    $('.particular-category').each(function() {
        // Get the category title from the current div
        let categoryTitle = $(this).data('categorytitle');
        // Check if the category title matches onLoadCategory
        if (categoryTitle === onLoadCategory) {
            categoryExists = true; // Set flag to true
            return false; // Exit the loop early
        }
    });

    if (!isNullUndefined(onLoadCategory) && categoryExists) {

        filterCategoryFromUrl(onLoadCategory);
    }
}

//Function to load the data after user enter zipcode
async function appendDataByZipcode(zipCode) {
    let getAllStores = await loadStores(null, null, null, zipCode);
    if (isNullUndefined(getAllStores)) {
        $('#StoreNumberModal').modal('hide');
        $('.zip-input').addClass('error-border');
        $('#fasZipCodeInvalid').removeClass('d-none');
        var zipError = $("#zipError");
        var fasPageNoStoreForZipMsg = $('#fasPageNoStoreForZipMsg').attr('data-value');
        zipError.text(fasPageNoStoreForZipMsg);
        $('#notAvilableError').removeClass('d-none');
        controlZipCodeError();
    }
    else {
        //Call to get the formated Address and the zipcode.
        $('.storeData').empty().append(getAllStores);
        var fasNoStoreErrorMsg = $('.sd-page-store-msg').text();
        if (!isNullUndefined(fasNoStoreErrorMsg)) {
        	$("#zipError").text(fasNoStoreErrorMsg);
        	$('#notAvilableError').removeClass('d-none');
        } else {
        	$("#zipError").text('');
        	$('#notAvilableError').addClass('d-none');
        	$('#StoreNumberModal').modal('hide');
        }
        handleFasUrlChange('dataCall');
        $(`.particular-category[data-categorytitle="${allCatData}"]`).addClass('category-active');
        backTotop();
        mobileCatDropdown();
        __googleMapsCallback('appendAjaxCall');
        $('#findAStoreModal').modal('hide');
        currentAddress = $('#currentAddress').data('address');
        $('#stateZipInput').val(currentAddress);
		window.dataLayer.push({
	      'event': 'userStoreSearch'
	   });
        updateAddCookieParams(['.apply-now-button .acima-button-primary','.apply-for-both-btn .acima-button-primary','.est-leasing-cost']);
       dataLayerCall('onLoad', null, null);
    }
	filterCategoriesIfExist();
    
}

//Function to load data after user enters the address

async function appendDataByAddress(address) {
    try {
        let getAllStoresByAddress = await loadStores(null, null, address, null);
        let tempContainer = $('<div>').html(getAllStoresByAddress);
        let addressAvail = tempContainer.find('#isAddressUnavailable').data('addressavail');
        if(addressAvail === true) {
            $('#storeNotFoundError').removeClass('d-none');
            $('.store-input').addClass('error-border');
            $('#stateZipInput').focus();
            $('.store-input').removeClass('input-disabled');
        }
        else {
            $('.storeData').empty().append(getAllStoresByAddress);
            handleFasUrlChange('dataCall');
            $(`.particular-category[data-categorytitle="${allCatData}"]`).addClass('category-active');
            //Binding scroll element
            backTotop();
            mobileCatDropdown();
            __googleMapsCallback('appendAjaxCall');
            $('.store-input').removeClass('input-disabled');
            $('#storeNotFoundError').addClass('d-none');
            $('.store-input').removeClass('error-border');
            $('#stateZipInput').val($('#currentAddress').data('address'));
            $('#autocompleteOptions').empty().addClass('d-none');
            var currentZipCode = $('#currentZipCode').attr('data-currentZipCode');
            if (!isNullUndefined(currentZipCode)) {
            	$('.header-zipcode-popup').text(currentZipCode);
            }
        }
		
    }
    catch(error) {
        console.log(error);
    }
}

//Function to load data after user allows locations.
async function appendDataByUserLocation(position) {
    let curLatitude = position.coords.latitude;
    let curLongitude = position.coords.longitude;

    try {
        let getAllStoresByUsersLocation = await loadStores(curLatitude, curLongitude, null, null);
        $('.store-input').removeClass('input-disabled');
        $('.storeData').empty().append(getAllStoresByUsersLocation);
        handleFasUrlChange('dataCall');
        $(`.particular-category[data-categorytitle="${allCatData}"]`).addClass('category-active');
        backTotop();
        mobileCatDropdown();
        __googleMapsCallback('appendAjaxCall');
        let currentAddress = $('#currentAddress').data('address');
        $('#stateZipInput').val(currentAddress);
    }
    catch(error) {
        console.log(error);
    }
}

//function to call the Autocompletion API starts
async function updateAutocomplete(input) {
    try {
        let zipCodeAddress = null;
        let googleAutocomplete = google && new google.maps.places.AutocompleteService();
        if (!googleAutocomplete) {
            return;
        }
        let autoCompleteParams = {
            input: input,
            componentRestrictions: { country: "us" }
        };

        // If input is a zip code, we grab its location data and add it as the first option
        // of the autocomplete. We also use zip code location as the bias location for other
        // autocomplete suggestions.
        let isZipCode = input.match(/(\d{5})$/g);
        if (isZipCode) {
            let zipCodeLocation = await getAddressByZipCode(isZipCode);
            if (zipCodeLocation) {
                zipCodeAddress = zipCodeLocation.addressDescription;
                // Add zip as bias location.
                autoCompleteParams.location = new google.maps.LatLng(
                    zipCodeLocation.latitude,
                    zipCodeLocation.longitude
                );
                // Bias location radius is set in meters.
                autoCompleteParams.radius = 10000;
            }
        }

        // A callback that processes autocomplete suggestions.
        let autocompleteQueryCallback = function (predictions) {
            displayAutocompleteOptions(predictionsTransformer(predictions || [], zipCodeAddress));
        };

        // Finally, query Google API for autocomplete suggestions.
        googleAutocomplete.getQueryPredictions(autoCompleteParams, autocompleteQueryCallback);
    } catch (err) {
        console.error("maps", err);
    }
}

//Append the predictions
function displayAutocompleteOptions(predictedOptions) {
    $('#autocompleteOptions').empty();
    let inputWidth = $('.store-input').outerWidth();
    if(isElemExist($('#autocompleteOptions'))) {
        $('#autocompleteOptions').css('min-width', `${inputWidth}px`);
    }
    predictedOptions.forEach(option => {
      $('#autocompleteOptions').append(`<li>${option.description}</li>`);
    });
    if($('#autocompleteOptions li').length > 0) {
        $('#autocompleteOptions').removeClass('d-none');
    }
    else {
        $('#autocompleteOptions').addClass('d-none');
    }
    currentIndex = -1; // Reset the index when new options are displayed
}

//Prediction Transformer starts
function predictionsTransformer(predictions, firstAddress) {
    let filteredPredictions = predictions.filter(hasUsaInDescription);

    // Add first address as the first autocomplete option.
    if (firstAddress) {
        return [
            { description: firstAddress },
            ...filteredPredictions.filter(descriptionIsntFirstAddress(firstAddress)),
        ];
    }
    return filteredPredictions;
}

function hasUsaInDescription(prediction) {
    return prediction.description.endsWith(", USA");
}

function descriptionIsntFirstAddress(firstAddress) {
    return function (prediction) {
        return prediction.description !== firstAddress;
    };
}

//navigate autoComplete through arrows
function autoCompleteKeyNavigation() {
    let currentIndex = -1;

    $('#stateZipInput').on('keydown', function (event) {
        const $options = $('#autocompleteOptions li');
        if ($options.length > 0 && $('#autocompleteOptions').is(':visible')) {
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    currentIndex = (currentIndex + 1) % $options.length;
                    updateActiveOption($options, currentIndex);
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    currentIndex = (currentIndex - 1 + $options.length) % $options.length;
                    updateActiveOption($options, currentIndex);
                    break;
                case 'Enter':
                    event.preventDefault();
                    if (currentIndex >= 0) {
                        $options.eq(currentIndex).click();
                    } else {
                        $('#storeSearchForm').submit();
                    }
                    break;
                case 'Escape':
                    event.preventDefault();
                    $('#autocompleteOptions').addClass('d-none');
                    $('#stateZipInput').blur();
                    break;
            }
        } else if (event.key === 'Enter') {
            // Allow form submission when no autocomplete options are visible
            $('#storeSearchForm').submit();
        }
    });

    function updateActiveOption($options, index) {
        $options.removeClass('active');
        $options.eq(index).addClass('active');
    }
}

//To show hide the suggestion when user click out
$(document).click(function(event) {
    if (!$(event.target).closest('#stateZipInput, #autocompleteOptions').length) {
        $('#autocompleteOptions').addClass('d-none');
    }
});

$('#stateZipInput').focus(function() {
    if ($('#autocompleteOptions li').length > 0) {
        $('#autocompleteOptions').removeClass('d-none');
    }
});

//maps code

let allCategoryStores = [];

let map;
let youAreHereMarker;
let latFromArea;
let lngFromArea;

function __googleMapsCallback(getCall) {
    let lat = parseFloat($('#getLatLong').data('lat'));
    let long = parseFloat($('#getLatLong').data('long'));
    let latValue, lngValue;
    // Map center is set by default to Plano, TX
    let defaultLat = 33.0853066;
    let defaultLong = -96.8137516;

    if (!isNullUndefined(lat) && !isNaN(lat)) {
        latValue = lat;
    } 
    else if (!isNullUndefined(latFromArea) && !isNaN(latFromArea)) {
        latValue = latFromArea;
    } 
    else {
        latValue = defaultLat;
    }

    if (!isNullUndefined(long) && !isNaN(long)) {
        lngValue = long;
    } 
    else if (!isNullUndefined(lngFromArea) && !isNaN(lngFromArea)) {
        lngValue = lngFromArea;
    } 
    else {
        lngValue = defaultLong;
    }

    let mapCenter = {
        lat: latValue,
        lng: lngValue
    };
    // Initialize the map
    let mapOptions = {
        center: mapCenter, // Default center (San Francisco)
        zoom: 12,
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM,
        },
    };
    map = new google.maps.Map(document.getElementById("map"), mapOptions);

    //You are here marker.
    
    let checkUrlToMark = window.location.href;
    if (checkUrlToMark.includes('address')) {
        youAreHereMarker = new google.maps.Marker({
            position: mapCenter,
            map: map,
            icon: '/_ui/responsive/common/images/acima-icons/PinYouAreHere.png',
        });
    }

    google.maps.event.addListener(map, 'dragend', function () {
        if(!isElemExist($('.gm-style-iw.gm-style-iw-c'))) {
            $('.search-area-button').removeClass('d-none');
        }
        else {
            $('.search-area-button').addClass('d-none');
        }
    });

    google.maps.event.addListener(map, 'zoom_changed', function () {
        if(!isElemExist($('.gm-style-iw.gm-style-iw-c'))) {
            $('.search-area-button').removeClass('d-none');
        }
        else {
            $('.search-area-button').addClass('d-none');
        }
    });

    markStoreLocations(getCall);
    
}


//MarkStorelocations Fucntion
function markStoreLocations(getCall) {
    let selectedMarker = null;
    let infoWindow = new google.maps.InfoWindow();
    let previousSelectedLi = null;
    if ($('.store-list li').hasClass('store-active')) {
        $('.store-list li').removeClass('store-active');
    }
    let markers = {};
    let locations = [];
    if(getCall === 'appendAjaxCall' || getCall === 'urlCategoryIncludeCall') {
        allCategoryStores.length = 0;
    }

    $('.stores-list-wrapper ul li').each(function() {
        let lat = $(this).data('lat');
        let lng = $(this).data('long');
        let title = $(this).data('title');
        let address = $(this).data('address');
        let city = $(this).data('city');
        let state = $(this).data('state');
        let postalCode = $(this).data('postalcode');
        if(!isNullUndefined(lat) && !isNullUndefined(lng)) {
            locations.push({ lat, lng, title, address, city, state, postalCode });
            if(getCall === 'appendAjaxCall' || getCall === 'urlCategoryIncludeCall') {
                allCategoryStores.push($(this));
            }
        }
    });

    locations.forEach(location => {
        let locMarker = new google.maps.Marker({
            position: { lat: location.lat, lng: location.lng },
            map: map,
            title: location.title,
            address: location.address,
            city: location.city,
            state: location.state,
            postalCode: location.postalCode,
            icon: '/_ui/responsive/common/images/acima-icons/MapPin.png',
        });
        markers[location.title] = locMarker;
        // Add click event listener to each marker
        google.maps.event.addListener(locMarker, 'click', function () {
            handleMarkerClick(locMarker, 'click');
        });
    });

    $('.stores-list-wrapper ul li').on('mouseenter', function () {
        let title;
        title = $(this).data('title');
        
        if(!isNullUndefined(title)) {
            handleMarkerClick(markers[title], 'mouseenter');
        }
    })

    //handle marker click function
    function handleMarkerClick(locMarker, eventType) {
        if (selectedMarker) {
            selectedMarker.setIcon('/_ui/responsive/common/images/acima-icons/MapPin.png');
        }

        locMarker.setIcon('/_ui/responsive/common/images/acima-icons/map_pin_blue.png');

        if(youAreHereMarker) {
            youAreHereMarker.setMap(null);
        }
        
        // Store the clicked marker as the currently selected marker
        selectedMarker = locMarker;
        infoWindow.setContent('<div><h5>' + locMarker.title + '</h5><address>' + locMarker.address + '<br>' + locMarker.city + ', ' + locMarker.state + ', ' + locMarker.postalCode + '</address>');
        infoWindow.open(map, locMarker);

        let target = $('.stores-list-wrapper > ul > li').filter(function (e) {
            return $(this).data('title') === locMarker.title;
        });
        
        if (target.length) {
            if (previousSelectedLi) {
                previousSelectedLi.removeClass('store-active');
            }
            target.addClass('store-active');
            previousSelectedLi = target;
            
            if(eventType === 'click') {
                let $wrapper = $('.stores-list-wrapper');
                let targetOffsetTop = target.position().top + $wrapper.scrollTop();
                $wrapper.animate({
                    scrollTop: targetOffsetTop
                }, 1000);
            }
        }
    }
}

async function loadStores(latitude, longitude, address, zipCode) {
	
	let urlParams = new URLSearchParams(window.location.search);
	// Get the value of the 'category' parameter
	let selectedCategory = urlParams.get('category');
	if(!isNullUndefined(selectedCategory)) {
    	filterAndUpdateList(selectedCategory);
    }
	
    let data = await $.ajax({
        type: 'GET',
        url: ACC.config.encodedContextPath + "/find-a-store/getStores",
        beforeSend: function() {
            $('.full-page-spinner').show();
            $('#fasModalSubmit').addClass('set-btn-loading');
            $('#fasSubmitButton').addClass('set-btn-loading');
        },
        data: {
            latitude: latitude,
            longitude: longitude,
            address: address,
            zipCode: zipCode,
            category: selectedCategory
        },
        success:function (){
            $('.fas-zc-set').removeClass("d-none");
            $('.fas-zc-set-p').removeClass("d-none");
            $('.fas-not-zc-set').addClass("d-none");
            $('.fas-not-zc-set-p').addClass("d-none");
        },
        complete: function() {
            $('#fasModalSubmit').removeClass('set-btn-loading');
            $('#fasSubmitButton').removeClass('set-btn-loading');
        }
    });
    if (data.length === 0) {
        setTimeout(()=>{
            $('.full-page-spinner').hide();
        },500)
        return null;
    } else {
        setTimeout(()=>{
            $('.full-page-spinner').hide();
        },500)
        return data;
    }
}

async function loadGeoStores(lat, log, xmin, ymin, xmax, ymax) {
    let selectedStateCode = $('#selectedStateName').data('statename');
    try {
        let data = await $.ajax({
            type: 'GET',
            url: ACC.config.encodedContextPath + "/find-a-store/searchByMap",
            beforeSend: function() {
                $('.full-page-spinner').show();
                $('#search-this-area .search-img img').addClass('d-none');
                $('#search-this-area .search-img').addClass('set-btn-loading');
                $('#fasSubmitButton').addClass('set-btn-loading');
            },
            data: {
                xmin: xmin,
                ymin: ymin, 
                xmax: xmax, 
                ymax: ymax,
                lat: lat,
                log: log,
                stateCode: selectedStateCode,
            },
            complete: function() {
                $('#search-this-area .search-img img').removeClass('d-none');
                $('#search-this-area .search-img').removeClass('set-btn-loading');
                $('#fasSubmitButton').removeClass('set-btn-loading');
                $('.full-page-spinner').hide();
            },
        });
        return data;
    }
    catch(error) {
        console.error('Error fetching stores:', error);
        throw error;
    }
}


function mobileCatDropdown() {
    $("ul.dropdown-menu-self li").each(function() {
        if ($(this).find("p").text().trim() === allCatData) {
            $(this).remove();
        }
    });

    $('.dropdown-input-wrapper').click(function () {
        let dropdownToggleWidth = $('.dropdown-toggle-self').outerWidth();
        $('.dropdown-menu-self').css('max-width', `${dropdownToggleWidth}px`);
        $('.dropdown-menu-self').toggle(300)
        $('.dropdown-self').removeClass('active');
    });

    $('.dropdown-menu-self li').click(function () {
        let initiallySelectedText = $('.dropdown-toggle-self p').text().trim();

        let selectedMobileCategoryText = $(this).find('p').text().trim();
        let catCount = $(this).data('mobcatcount');
        if(initiallySelectedText !== selectedMobileCategoryText) {
            $('ul.store-list').empty().append(allCategoryStores);
            $('.particular-category').removeClass('category-active');
            let selectedLi = $(this).html();
            $('.dropdown-toggle-self').empty().append(selectedLi);
            let selectedText = $('.dropdown-toggle-self p').text().trim();
            if(selectedText === 'Select a category') {
                selectedText = allCatData;
            }
            setUrlCategory = selectedText;
            handleFasUrlChange('categoryCall');
            filterAndUpdateList(selectedText);
            allCategorySection(selectedText);
            let findCategory = $('.particular-category[data-categorytitle="' + selectedText + '"]');
            findCategory.addClass('category-active');
            dataLayerCall('particularCat', selectedText, catCount);
        }
        $('.dropdown-menu-self').hide(300);
        $('.dropdown-self').addClass('active');
    });

    $(document).click(function (e) {
        if (!$(e.target).closest('.dropdown-self').length) {
            $('.dropdown-menu-self').hide(300);
            $('.dropdown-self').addClass('active');
        }
    });

    $(document).keydown(function(e) {
        if(e.key === 'Escape') {
            $('.dropdown-menu-self').hide(300);
            $('.dropdown-self').addClass('active');
        }
    })
}

function filterMobileCat(getSelectedCategory) {
    let selectedLi = $(".dropdown-menu-self li").filter(function() {
        return $(this).find("p").text().trim() === getSelectedCategory;
    });

    if(!isNullUndefined(selectedLi)) {
        $(".dropdown-toggle-self").empty();
        $(".dropdown-toggle-self").append(selectedLi.contents().clone());
    }
}

function backTotop() {
    let backToTop = $('.back-to-top');
    let storesListWrapper = $('.stores-list-wrapper');
    let backToTopWrapper = $('#backToTopWrapper');
    let storesMapWrapper = $('.stores-map-wrapper');

    if ($(window).width() < 768) {
        $(window).on('scroll', function () {
            if ($(window).scrollTop() > storesMapWrapper.offset().top) {
                backToTopWrapper.removeClass('d-none');
            }
            else {
                backToTopWrapper.addClass('d-none');
            }
        })
        backToTop.on('click', function () {
            $('html, body').animate({ scrollTop: storesMapWrapper.offset().top }, '300');
            return false;
        });
    }
    else {
        storesListWrapper.on('scroll', function () {
            if (storesListWrapper.scrollTop()) {
                backToTopWrapper.removeClass('d-none');
            } else {
                backToTopWrapper.addClass('d-none');
            }
        });

        backToTop.on('click', function () {
            storesListWrapper.animate({ scrollTop: 0 }, '300');
            return false;
        });
    }
}

//catgory code
let setUrlCategory;
$(document).on('click', '.all-categories .particular-category', function() {
    $('ul.store-list').empty().append(allCategoryStores);
    $('.particular-category').removeClass('category-active');
    let selectedCategory = $(this).data('categorytitle');
    let catCount = $(this).data('catcount');
    setUrlCategory = selectedCategory;
    handleFasUrlChange('categoryCall');
    $(this).addClass('category-active');
    filterAndUpdateList(selectedCategory);
    allCategorySection(selectedCategory);
    filterMobileCat(selectedCategory);
    dataLayerCall('particularCat', selectedCategory, catCount);
})

$(document).on('click', '.sub-cat-btn', function() {
    $('ul.store-list').empty().append(allCategoryStores);
    $('.particular-category').removeClass('category-active');
    let selectedCatText = $(this).text().trim();
    setUrlCategory = selectedCatText;
    handleFasUrlChange('categoryCall');
    filterAndUpdateList(selectedCatText);
    allCategorySection(selectedCatText);
    filterMobileCat(selectedCatText);
    let findCategory = $('.particular-category[data-categorytitle="' + selectedCatText + '"]');
    findCategory.addClass('category-active');
    dataLayerCall('particularCat', selectedCatText, null);
})

//FilterAnd Update list function defined
function filterAndUpdateList(selectedCategory) {
    let filteredItems = [];

    // Iterate over each store list item
    $('ul.store-list li').each(function() {

        let listItem = $(this);

        let storeCategories = listItem.find('.store-category .sub-cat-btn');

        // Check if selected category matches the button text
        storeCategories.each(function() {
            let categoryText = $(this).text().trim();
            if (categoryText === selectedCategory) {
                filteredItems.push(listItem); // Push parent li element to filteredItems array
            }
        });
    });

    // Clear existing list and append filtered items
    $('ul.store-list').empty().append(filteredItems);
    __googleMapsCallback('categoryCall');

    if(selectedCategory === allCatData) {
        $('ul.store-list').empty().append(allCategoryStores);
        __googleMapsCallback('categoryCall');
    }
}

//Filter category section function
function allCategorySection(getSelectedCategory) {  
    $('.particular-category').each(function() {
        if($(this).data('categorytitle') === getSelectedCategory || $(this).data('categorytitle') === allCatData || getSelectedCategory === allCatData) {
            $(this).attr('style', 'display: inline-flex !important');
        }
        else {
            $(this).attr('style', 'display: none !important');
        }
    })
}

async function searchThisArea() {
    let mapCenter = map.getCenter();
    let bounds = map.getBounds();
    let query = {
        lat: mapCenter.lat(),
        lng: mapCenter.lng(),
        xmax: bounds.getNorthEast().lng(),
        ymax: bounds.getNorthEast().lat(),
        xmin: bounds.getSouthWest().lng(),
        ymin: bounds.getSouthWest().lat(),
    };
    
    //here we get the lat lng
    let center = getCenterByBoundary(query);
    latFromArea = center.lat;
    lngFromArea = center.lng;
    try {
        let getAllStoresByArea = await loadGeoStores(center.lat, center.lng, query.xmin, query.ymin, query.xmax, query.ymax);
        $('.storeData').empty().append(getAllStoresByArea);
        $(`.particular-category[data-categorytitle="${allCatData}"]`).addClass('category-active');
        __googleMapsCallback('appendAjaxCall');
        backTotop();
        mobileCatDropdown();
        if(!isNullUndefined(currentAddress)) {
            $('#stateZipInput').val(currentAddress);
        }
    } 
    catch (error) {
        console.log(error)
    }
}

function getCenterByBoundary({ xmin, ymin, xmax, ymax }) {
    let bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(ymin, xmin),
        new google.maps.LatLng(ymax, xmax)
    );
    let center = bounds.getCenter();
    return { lat: center.lat(), lng: center.lng() };
}

//handle url change.
let dataCallUrl;
function handleFasUrlChange(getCall) {
    if(getCall === 'dataCall') {
        let currentAddress = $('#currentAddress').data('address');
        if (!isNullUndefined(currentAddress)) {
            let searchParams = new URLSearchParams(window.location.search);
            searchParams.set('address', currentAddress);
            let newURL = window.location.origin + window.location.pathname + '?' + searchParams.toString();
            window.history.pushState({}, '', newURL);
        }
        dataCallUrl = window.location.href;
    }
    else if(getCall === 'categoryCall' && !isNullUndefined(setUrlCategory)) {
        let newUrl;
        if(setUrlCategory === allCatData) {
            let searchParams = new URLSearchParams(window.location.search);
            searchParams.delete('category');
            newUrl = window.location.origin + window.location.pathname + '?' + searchParams.toString();
        }
        else {
            let searchParams = new URLSearchParams(window.location.search);
            searchParams.set('category', setUrlCategory);
            newUrl = window.location.origin + window.location.pathname + '?' + searchParams.toString();
            
        }
        window.history.pushState({}, '', newUrl);
    }
    showShopOnlineCard();
}
// Add popstate event listener to handle browser navigation
window.addEventListener('popstate', function (event) {
    location.reload();
});

//on URL reload - speacially for url with cats
$(window).on('load', function() {
    // Code to execute when the entire page is fully loaded
    let checkUrl = window.location.href;
    if(!checkUrl.includes('&category')) {
        dataCallUrl = checkUrl;
        __googleMapsCallback('appendAjaxCall');
    }
    else {
        let partUrl = checkUrl.split("&category");
        let newPartUrl = partUrl[0];
        dataCallUrl = newPartUrl;
        __googleMapsCallback('urlCategoryIncludeCall');
    }
    filterCategoriesIfExist();
})

function filterCategoryFromUrl(onLoadCategory) {
    $('ul.store-list').empty().append(allCategoryStores);
    $('.particular-category').removeClass('category-active');
    filterAndUpdateList(onLoadCategory);
    allCategorySection(onLoadCategory);
    filterMobileCat(onLoadCategory);
    let findCategory = $('.particular-category[data-categorytitle="' + onLoadCategory + '"]');
    findCategory.addClass('category-active');
}

//For shop online card.
$(document).ready(function() {
    showShopOnlineCard();
    $('.card-close-btn').on('click', function() {
        $('.shop-card-content').addClass('d-none');
    })
})

let shopCardTimeout;
function showShopOnlineCard() {
    const storeList = $('.stores-list-wrapper .store-list');
    const shopCardContent = $('.shop-card-content');
    const selectedStateName = $('#selectedStateName').data('statename').trim().toLowerCase();

    if (storeList.length > 0) {

        clearTimeout(shopCardTimeout);
        
        if (selectedStateName === 'pr') {
            shopCardContent.addClass('d-none');
        } else {
            shopCardTimeout = setTimeout(() => {
                shopCardContent.removeClass('d-none');
            }, 40000); // 40 seconds delay
        }
    }
}

//function to validate zipcode
function validateFindStoreZipCode(zipcode) {
	var zipCodeRegex = /^\d{5}$/;
	if (zipCodeRegex.test(zipcode)) {
		return true;
	} else {
		return false;
	}
}

function controlZipCodeError() {
    $('#zip').on('input', function(event) {
        if(event.target.value.length === 5) {
            $('#lessCharError').addClass('d-none');
            $('.zip-input').removeClass('error-border');
            $('#fasZipCodeInvalid').addClass('d-none');
        }
        else {
            $('#lessCharError').removeClass('d-none');
            $('.zip-input').addClass('error-border');
            $('#fasZipCodeInvalid').addClass('d-none');
        }
    })
}

function dataLayerCall(callType, selectedCategory, catCount) {
    let category = '__VIEW_ALL__'
    let completeCatCount = catCount;
    if(callType === 'particularCat' && selectedCategory !== allCatData) {
        category = selectedCategory
    }
    var addressDataLayer = $('#currentAddress').attr('data-address');
    var latDataLayer = $('#getLatLong').attr('data-lat');
    var longDataLayer = $('#getLatLong').attr('data-long');
    var stateDataLayer = $('#selectedStateName').attr('data-stateName');
    var storeCountDataLayer = $('#selectedStoreCount').attr('data-StoreCount');
    if(callType !== 'particularCat') {
        completeCatCount = storeCountDataLayer;
    }
    window.dataLayer.push({
        'event': 'storeSearchResults',
        'location': {
            'address': addressDataLayer,
            'lat': latDataLayer,
            'lng': longDataLayer,
            'state': stateDataLayer
        },
        'results': completeCatCount,
        'category': category
    });
}